module.exports = __webpack_public_path__ + "img/wallet.b1b82c4d.svg";